import { render, staticRenderFns } from "./ExpertCategory.vue?vue&type=template&id=73019e6d&"
import script from "./ExpertCategory.vue?vue&type=script&lang=js&"
export * from "./ExpertCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports